import _ from 'lodash'

export const stepsToMakeOffer = [
  {
    stepItem: 'Basic Information',
    completed: false,
    elmId: 'basic_information',
    key: 'basic_information',
    canProceed: state => state.selection,
  },
  {
    stepItem: 'Acknowledgements',
    completed: false,
    elmId: 'acknowledgements',
    key: 'acknowledgements',
    canProceed: state => state.fullName,
  },
  {
    stepItem: 'Complete',
    completed: false,
    elmId: 'complete',
    key: 'complete',
    canProceed: () => true,
  },
]

export const stepsToSave = stepsToMakeOffer.filter((val, i) => i !== 1)

/**
 * Update a step with completed status (t/f) in a state-friendly way.
 * @param {array} steps
 * @param {number} index
 * @param {boolean} completed
 * @returns new array with update step included
 */
export const updateCompletedStep = (steps, index, completed) => {
  const pre = steps.slice(0, index)
  const post = steps.slice(index + 1)
  const newStep = _.cloneDeep(steps[index])
  newStep.completed = completed
  return [...pre, newStep, ...post]
}
